<template>
  <div>
    <v-layout row wrap>
      <v-flex md12>
        <wallet-by-customers :date="date"></wallet-by-customers>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import walletByCustomers from '@/components/panel/info_schedules/WalletByCustomers';

export default {
  props: ['date'],
  components: {
    walletByCustomers,
  },
  data() {
    return {
    };
  },
};
</script>


// WEBPACK FOOTER //
// src/components/panel/info_schedules/Index.vue